import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { toaster } from '../../helpers/toaster';
import { Form, TextInput, Button, Loading } from 'carbon-components-react';
import Select from 'react-select';
import MyModal from '../../components/Modal/Modal';
import { deleteDevelopmentStatus } from '../../api/developmentStatuss';

const DeleteDevelopmentStatusModal = ({
  open = false,
  refreshList = () => {},
  onClose = () => {},
  developmentStatusList = [],
  deleteItem,
  }) => {
  // loading is for initial component preloading
  const [loading, setLoading] = useState(false);
  // processing is for user initiated component api calls
  const [processing, setProcessing] = useState(false);

  const addBtnStyle = {
    padding: "11px 18px",
    height: "auto",
    minHeight: "unset",
    borderRadius: "10px",
    fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
    fontWeight: 700,
    fontSize: "13.5px",
    width: "fit-content",
    marginLeft: "10px",
  };

  const deleteDevelopmentStatusSubmit = (e) => {
    setProcessing(true);
    deleteDevelopmentStatus(deleteItem.id)
    .then(res => {
      toaster("Development Status deleted successfully", "success")
      onClose();
      refreshList();
      setProcessing(false);
    }).catch(error => {
      toaster("Could not delete developmentStatus", "error")
      setProcessing(false);
    });
  };

  const additionalProps = {
    className: 'some-class',
    onSubmit: deleteDevelopmentStatusSubmit
  };

  return (
    <MyModal
      modalHeading="Delete Development Status"
      size="sm"
      open={open}
      onRequestClose={() => {
        onClose();
      }}
    >
      <ModalContent>
      
      {
          processing || loading ? 
          <Loading/> 
          :
          <></>
        }
        <ConfirmText style={{ marginBottom: "18px" }}>{`Delete ${deleteItem?.name}?`}</ConfirmText>
        <Form {...additionalProps}>

          <ModalFooter>

          <Button 
              kind="secondary"
              onClick={() => {
                onClose();
              }}
              style={addBtnStyle}  
            >Cancel</Button>

            <Button
              type="submit"
              kind="danger"
              // onClick={() => onCreate()}
              style={addBtnStyle}  
            >Yes</Button>
          </ModalFooter>

        </Form>

      </ModalContent>
    </MyModal>
  );
};

export default DeleteDevelopmentStatusModal;

const ModalContent = styled.div`
display: flex;
flex-direction: column;
`

const ModalFooter = styled.div`
width: 100%;
display: flex;
justify-content: flex-end;
`
const ConfirmText = styled.div`
`
